import { h } from 'preact';
import { ANNOTATION_EVENT } from 'constants/events';
import { BaseAnnotation } from './base_annotation';
import { InvisibleAnnotation } from 'rendering/components/invisible_annotation';

export class OnTimeAnnotation extends BaseAnnotation {
    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);
        
        if (!this.state.onTimeFired && this.props.currentTime >= this.props.start) {
            this.setState({
                onTimeFired: true
            });

            if (this.props.setVariables) {
                this.eventBus.emit(ANNOTATION_EVENT.EXECUTABLE_AVAILABLE, this.props.setVariables);
            }
        }
    }

    render () {
        return <InvisibleAnnotation { ...this.dataAttrs } />
    }

    get defaultState() {
        return {
            onTimeFired: false
        }
    }

    static get schemaType() {
        return 'ontime';
    }
}